import { Controller } from "react-hook-form";
import { Input, Select } from "antd";

interface FormFieldProps {
  name: string;
  control: any;
  label: string;
  placeholder?: string;
  type?: "input" | "select";
  options?: { label: string; value: string }[];
  errors?: Record<string, any>;
  disabled?: boolean;
}

export const FormField = ({
  name,
  control,
  label,
  placeholder,
  type = "input",
  options = [],
  errors,
  disabled,
}: FormFieldProps) => (
  <div className="flex flex-col gap-1 w-full sm:w-1/2">
    <label className="">{label}</label>

    <Controller
      name={name}
      control={control}
      render={({ field }) =>
        type === "select" ? (
          <Select
            {...field}
            placeholder={placeholder}
            options={options}
            disabled={disabled}
            className="w-full"
          />
        ) : (
          <Input {...field} placeholder={placeholder} disabled={disabled} />
        )
      }
    />

    {errors?.[name] && (
      <span className="text-red-500 text-xs">
        {errors[name]?.message as string}
      </span>
    )}
  </div>
);
